import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { createMuiTheme, ThemeProvider } from '@material-ui/core';
import RTL from './RTL';

const theme = createMuiTheme({
  direction: 'rtl',
});

ReactDOM.render(
  <React.StrictMode>
    <RTL>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </RTL>
  </React.StrictMode>,
  document.getElementById('root')
);
